module.exports = __webpack_public_path__ + "img/amazonWeavr.786ed7a4.svg";